import { $enum } from 'ts-enum-util';

import { EmployeePageTabType } from '../../EmployeePage/EmployeePageContent';

export type CarrierApplicationModalStepSubmit = () => Promise<{
  navigate: boolean;
}>;

export const getEmployeeTabRoute = (tab: EmployeePageTabType) =>
  $enum
    .mapValue(tab)
    .with<
      | 'OPS_EMPLOYEE_ZORRO_PAY_TAB'
      | 'OPS_EMPLOYEE_PLANS_TAB'
      | 'OPS_EMPLOYEE_ACTIVITY_LOG_TAB'
      | 'OPS_EMPLOYEE_FILES_TAB_V2'
      | 'OPS_EMPLOYEE_MEMBERS_TAB'
    >({
      [EmployeePageTabType.ZORRO_PAY]: 'OPS_EMPLOYEE_ZORRO_PAY_TAB',
      [EmployeePageTabType.PLANS]: 'OPS_EMPLOYEE_PLANS_TAB',
      [EmployeePageTabType.ACTIVITY_LOG]: 'OPS_EMPLOYEE_ACTIVITY_LOG_TAB',
      [EmployeePageTabType.FILES]: 'OPS_EMPLOYEE_FILES_TAB_V2',
      [EmployeePageTabType.MEMBERS]: 'OPS_EMPLOYEE_MEMBERS_TAB',
    });

export enum CarrierApplicationModalStepType {
  ENROLLMENT_INFO = 'ENROLLMENT_INFO',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  COMPLETE_APPLICATION = 'COMPLETE_APPLICATION',
  REVIEW = 'REVIEW',
}

export const getCarrierApplicationModalStepConfig = (
  step: CarrierApplicationModalStepType
) =>
  $enum.mapValue(step).with<{
    prevStep?: CarrierApplicationModalStepType;
    nextStep: CarrierApplicationModalStepType;
    stepIndex: number;
    label: string;
    withStepper: boolean;
  }>({
    [CarrierApplicationModalStepType.ENROLLMENT_INFO]: {
      nextStep: CarrierApplicationModalStepType.PAYMENT_METHOD,
      label: 'Enrollment info',
      stepIndex: 0,
      withStepper: true,
    },
    [CarrierApplicationModalStepType.PAYMENT_METHOD]: {
      prevStep: CarrierApplicationModalStepType.ENROLLMENT_INFO,
      nextStep: CarrierApplicationModalStepType.COMPLETE_APPLICATION,
      label: 'Payment method',
      stepIndex: 1,
      withStepper: true,
    },
    [CarrierApplicationModalStepType.COMPLETE_APPLICATION]: {
      prevStep: CarrierApplicationModalStepType.PAYMENT_METHOD,
      nextStep: CarrierApplicationModalStepType.ENROLLMENT_INFO,
      label: 'Complete application',
      stepIndex: 2,
      withStepper: true,
    },
    [CarrierApplicationModalStepType.REVIEW]: {
      prevStep: CarrierApplicationModalStepType.COMPLETE_APPLICATION,
      nextStep: CarrierApplicationModalStepType.COMPLETE_APPLICATION,
      label: 'Review',
      stepIndex: 3,
      withStepper: false,
    },
  });
